'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Api = require('@teko/api');

const getError = (resp) => {
  const message = resp.message;
  return new Api.ApiError(message, resp.statusCode, resp);
};

exports.getError = getError;
